import { render, staticRenderFns } from "./DetailInbox.vue?vue&type=template&id=6a2bfde9"
import script from "./DetailInbox.vue?vue&type=script&lang=js"
export * from "./DetailInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2bfde9')) {
      api.createRecord('6a2bfde9', component.options)
    } else {
      api.reload('6a2bfde9', component.options)
    }
    module.hot.accept("./DetailInbox.vue?vue&type=template&id=6a2bfde9", function () {
      api.rerender('6a2bfde9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/DetailInbox.vue"
export default component.exports